
import { IMunicipio, IPlanoGovernoAnexo, IPlanoGovernoAnexoCreate, IPlanoGovernoAnexoUpdate, IPlanoGovernoEixo, IPlanoGovernoEixoCreate, IPlanoGovernoEixoMeta, IPlanoGovernoEixoUpdate, IPlanoGovernoMetaCreate, IPlanoGovernoMetaDetalhes, IPlanoGovernoMetaUpdate } from "../../../pages/PlanoDeGoverno/interfaces";
import { getToken } from "../../LStorage/token";
import { urlHttpGov } from "../../urls";
import PlanoGovernoMapper from "../mappers/PlanoGovernoMapper";
import privateHttpClient from "../privateHttpClient";

class PlanoGovernoService {
    private planoGovernoBaseURL = `${urlHttpGov}/plano_de_governo`;
    private baseURL = `${urlHttpGov}`;

    async getMunicipiosDoContrato(idContrato: string | number, signal: AbortSignal): Promise<IMunicipio[]> {
        const { data } = await privateHttpClient.get(`${this.baseURL}/backend/cidades/contrato/${idContrato}`, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            signal
        });

        return data.map((role: any) => PlanoGovernoMapper.toDomain(role));
    }

    async getMunicipios(signal: AbortSignal): Promise<IMunicipio[]> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/municipio`, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            signal
        });
        return data;
    }

    async getAnexosByIdIbge(idIbge: number, signal: AbortSignal): Promise<IPlanoGovernoAnexo[]> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/anexo/cidade/${idIbge}`, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            signal
        });
        return data;
    }

    async getUrlAnexoByArquivo(arquivo: string, signal: AbortSignal): Promise<{ arquivo_url: string }> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/anexo/arquivo/${arquivo}`, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            signal
        });
        return data;
    }

    async getEixosByIdIbge(idIbge: number, signal: AbortSignal): Promise<IPlanoGovernoEixo[]> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/eixo/cidade/${idIbge}`, {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
            signal
        });
        return data;
    }

    async createEixo(eixo: IPlanoGovernoEixoCreate): Promise<IPlanoGovernoEixo> {
        const { data } = await privateHttpClient.post(`${this.planoGovernoBaseURL}/eixo`, eixo, {
            headers: {
                "Authorization": `Bearer ${getToken()}`
            },
        });

        return data;
    }

    async createAnexo(anexo: FormData): Promise<IPlanoGovernoAnexo> {
        const { data } = await privateHttpClient.post(`${this.planoGovernoBaseURL}/anexo`, anexo, {
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "multipart/form-data"
            },
        });

        return data;
    }

    async updateEixo(eixoUuid: string, eixo: IPlanoGovernoEixoUpdate): Promise<IPlanoGovernoEixo> {
        const { data } = await privateHttpClient.put(`${this.planoGovernoBaseURL}/eixo/${eixoUuid}`, eixo, {
            headers: {
                "Authorization": `Bearer ${getToken()}`
            },
        });

        return data;
    }

    async updateAnexo(anexoUuid: string, anexo: FormData): Promise<IPlanoGovernoAnexo> {
        const { data } = await privateHttpClient.put(`${this.planoGovernoBaseURL}/anexo/${anexoUuid}`, anexo, {
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "multipart/form-data"
            },
        });

        return data;
    }

    async getMetasByEixoUuid(eixoUuid: string, signal: AbortSignal): Promise<IPlanoGovernoEixoMeta[]> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/meta/eixo/${eixoUuid}`, {
            signal
        });

        return data;
    }

    async getEixoByUuid(eixoUuid: string, signal: AbortSignal): Promise<IPlanoGovernoEixo> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/eixo/${eixoUuid}`, {
            headers: {
                "Authorization": `Bearer ${getToken()}`
            },
            signal
        });

        return data;
    }

    async deleteEixoByUuid(eixoUuid: string) {
        return privateHttpClient.delete(`${this.planoGovernoBaseURL}/eixo/${eixoUuid}`, {
            headers: {
                // "Authorization": `Bearer ${this.token}`
                "Authorization": `Bearer ${getToken()}`
            }
        });
    }

    async deleteAnexoByUuid(eixoUuid: string) {
        return privateHttpClient.delete(`${this.planoGovernoBaseURL}/anexo/${eixoUuid}`, {
            headers: {
                // "Authorization": `Bearer ${this.token}`
                "Authorization": `Bearer ${getToken()}`
            }
        });
    }


    async getDetalhesMetaByUuid(metaUuid: string, signal: AbortSignal): Promise<IPlanoGovernoMetaDetalhes> {
        const { data } = await privateHttpClient.get(`${this.planoGovernoBaseURL}/meta/${metaUuid}`, {
            headers: {
                "Authorization": `Bearer ${getToken()}`
            },
            signal
        });

        return data;
    }

    async createMeta(meta: IPlanoGovernoMetaCreate): Promise<IPlanoGovernoEixoMeta> {
        const { data } = await privateHttpClient.post(`${this.planoGovernoBaseURL}/meta/`, meta, {
            headers: {
                // "Authorization": `Bearer ${this.token}`
                "Authorization": `Bearer ${getToken()}`
            },
        });

        return data;
    }

    async updateMeta(metaUuid: string, meta: IPlanoGovernoMetaUpdate): Promise<IPlanoGovernoEixoMeta> {

        const { data } = await privateHttpClient.put(`${this.planoGovernoBaseURL}/meta/${metaUuid}`, meta, {
            headers: {
                "Authorization": `Bearer ${getToken()}`
            },
        });

        return data;
    }

    async deleteMetaById(metaUuid: string) {
        return privateHttpClient.delete(`${this.planoGovernoBaseURL}/meta/${metaUuid}`, {
            headers: {
                // "Authorization": `Bearer ${this.token}`
                "Authorization": `Bearer ${getToken()}`
            }
        });
    }



}

export default new PlanoGovernoService();
